import { Component, Input, OnInit } from '@angular/core';
import { FeecappingRules } from '@app/core/models/journey/enum/tariff-rule.enum';
import { Tap } from '@app/core/models/journey/tap';

@Component({
  selector: 'pp-tap-fare-multivalidation',
  templateUrl: './tap-fare-multivalidation.component.html',
  styleUrls: ['./tap-fare-multivalidation.component.css']
})
export class TapFareMultivalidationComponent implements OnInit {

  @Input() tap: Tap;

  @Input() journeyFeeCappingStatus: boolean;

  @Input() displayDetailedMode: boolean;

  feeCappingRules = FeecappingRules.feeCappingRules;

  showAmountForJourneyInProgressOrDone: boolean = false;
  showAmountForFeecapping: boolean = false;
  showPassengersDetail: boolean = false;
  showTimeFrame: boolean = false;
  nbTimeframe: number = 0;

  ngOnInit(): void {
    if (this.tap && this.tap.fare && this.tap.fare.tariffRule) {
      this.showAmountForJourneyInProgressOrDone = this.showAmountForJourneyInprogressOrDone();
      this.showTimeFrame = this.showTimeFrameForFeecapping();
      this.showAmountForFeecapping = this.showAmountForJourneyFeecapping();
      this.showPassengersDetail = this.showPassengersDetailForCurrentTap();
    }
  }

  private showAmountForJourneyInprogressOrDone(): boolean {
    return !this.journeyFeeCappingStatus && (this.tap.fare.tariffRule.toString() === 'FIXED' || this.tap.fare.tariffRule.toString() === 'MULTIPLE') && +this.tap.fare.amountMoney != 0;
  }

  private showAmountForJourneyFeecapping(): boolean {
    return +this.tap.fare.amountMoney != 0 && (this.tap.fare.tariffRule.toString() === 'FIXED' || this.tap.fare.tariffRule.toString() === 'MULTIPLE' || this.feeCappingRules.includes(this.tap.fare.tariffRule));
  }

  private showTimeFrameForFeecapping(): boolean {
    this.nbTimeframe = this.tap.fare.passengersDetail.filter(p => p.tariffRule === 'TIMEFRAME').length;
    return this.tap.fare.tariffRule.toString() === 'TIMEFRAME' || (this.tap.fare.tariffRule.toString() === 'MULTIPLE' && this.nbTimeframe > 0)
  }

  private showPassengersDetailForCurrentTap(): boolean {
    return this.tap.type.toString() !== 'TAP-CONTROL' && (!this.journeyFeeCappingStatus || (this.journeyFeeCappingStatus && this.displayDetailedMode));
  }

}
